import _classCallCheck from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/bennettslin/Projects/bobtail_dominoes_app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Gain } from "../../core/context/Gain";
import { ToneAudioNode } from "../../core/context/ToneAudioNode";
import { optionsFromArguments } from "../../core/util/Defaults";
/**
 * Solo lets you isolate a specific audio stream. When an instance is set to `solo=true`,
 * it will mute all other instances of Solo.
 * @example
 * const soloA = new Tone.Solo().toDestination();
 * const oscA = new Tone.Oscillator("C4", "sawtooth").connect(soloA);
 * const soloB = new Tone.Solo().toDestination();
 * const oscB = new Tone.Oscillator("E4", "square").connect(soloB);
 * soloA.solo = true;
 * // no audio will pass through soloB
 * @category Component
 */

export var Solo = /*#__PURE__*/function (_ToneAudioNode) {
  _inherits(Solo, _ToneAudioNode);

  var _super = _createSuper(Solo);

  function Solo() {
    var _this;

    _classCallCheck(this, Solo);

    _this = _super.call(this, optionsFromArguments(Solo.getDefaults(), arguments, ["solo"]));
    _this.name = "Solo";
    var options = optionsFromArguments(Solo.getDefaults(), arguments, ["solo"]);
    _this.input = _this.output = new Gain({
      context: _this.context
    });

    if (!Solo._allSolos.has(_this.context)) {
      Solo._allSolos.set(_this.context, new Set());
    }

    Solo._allSolos.get(_this.context).add(_assertThisInitialized(_this)); // set initially


    _this.solo = options.solo;
    return _this;
  }

  _createClass(Solo, [{
    key: "solo",
    get:
    /**
     * Isolates this instance and mutes all other instances of Solo.
     * Only one instance can be soloed at a time. A soloed
     * instance will report `solo=false` when another instance is soloed.
     */
    function get() {
      return this._isSoloed();
    },
    set: function set(solo) {
      if (solo) {
        this._addSolo();
      } else {
        this._removeSolo();
      }

      Solo._allSolos.get(this.context).forEach(function (instance) {
        return instance._updateSolo();
      });
    }
    /**
     * If the current instance is muted, i.e. another instance is soloed
     */

  }, {
    key: "muted",
    get: function get() {
      return this.input.gain.value === 0;
    }
    /**
     * Add this to the soloed array
     */

  }, {
    key: "_addSolo",
    value: function _addSolo() {
      if (!Solo._soloed.has(this.context)) {
        Solo._soloed.set(this.context, new Set());
      }

      Solo._soloed.get(this.context).add(this);
    }
    /**
     * Remove this from the soloed array
     */

  }, {
    key: "_removeSolo",
    value: function _removeSolo() {
      if (Solo._soloed.has(this.context)) {
        Solo._soloed.get(this.context).delete(this);
      }
    }
    /**
     * Is this on the soloed array
     */

  }, {
    key: "_isSoloed",
    value: function _isSoloed() {
      return Solo._soloed.has(this.context) && Solo._soloed.get(this.context).has(this);
    }
    /**
     * Returns true if no one is soloed
     */

  }, {
    key: "_noSolos",
    value: function _noSolos() {
      // either does not have any soloed added
      return !Solo._soloed.has(this.context) || Solo._soloed.has(this.context) && Solo._soloed.get(this.context).size === 0;
    }
    /**
     * Solo the current instance and unsolo all other instances.
     */

  }, {
    key: "_updateSolo",
    value: function _updateSolo() {
      if (this._isSoloed()) {
        this.input.gain.value = 1;
      } else if (this._noSolos()) {
        // no one is soloed
        this.input.gain.value = 1;
      } else {
        this.input.gain.value = 0;
      }
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(Solo.prototype), "dispose", this).call(this);

      Solo._allSolos.get(this.context).delete(this);

      this._removeSolo();

      return this;
    }
  }], [{
    key: "getDefaults",
    value: function getDefaults() {
      return Object.assign(ToneAudioNode.getDefaults(), {
        solo: false
      });
    }
  }]);

  return Solo;
}(ToneAudioNode);
/**
 * Hold all of the solo'ed tracks belonging to a specific context
 */

Solo._allSolos = new Map();
/**
 * Hold the currently solo'ed instance(s)
 */

Solo._soloed = new Map();